export const touchSupport: boolean =
  'ontouchstart' in window || !!navigator.msMaxTouchPoints;
